import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { UserType } from "muminsmart-utils";
import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";
import Loader from "@/app/components/common/Loader";

export default function CustomerLayoutRoute() {
  const { data: session, status } = useAuth();

  if (status === "loading" && !session) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  const canAccessHome =
    session?.user?.type === UserType.User ||
    session?.user?.type === UserType.Seller;

  if (!canAccessHome) {
    return (
      <div className={`${styles.homeLayout}`} style={layoutBackgrounds.home}>
        <main>
          <div className="flex items-center justify-center h-[calc(100vh-140px)]">
            <p className="text-lg">
              You are not authorized to access this page.
            </p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className={styles.homeLayout} style={layoutBackgrounds.home}>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
